export const lang = {
  
};

export const fr = lang;
